<app-copy-flow-links [flowId]="flowId" />
@if (
  !isLoading &&
  insuranceFlowData &&
  policy &&
  policy.proposalState === 'POLICY_CREATED'
) {
  <button class="lty-btn lty-btn-primary" (click)="leadModal.openModal()" i18n>
    Nouvelle demande
  </button>

  <app-add-lead-modal
    [customerId]="policy.memberDetails.memberId!"
    [memberId]="policy.familyMemberDetails.familyMemberId!"
    [originalProposalId]="policy.proposalId"
    [navigateOnSuccess]="false"
    #leadModal
    (leadCreated)="leadCreated.emit($event)"
  />
  <app-init-commission-button
    [disabled]="!!policy?.commissionDetails"
    [proposalId]="policy?.proposalId!"
    (done)="refresh()"
  />
}
